import { inject, Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { MultisiteService } from '@df/core/service/multisite';
import { Url } from '@df/core/service/url';
import { Status } from '@df/core/status';

@Injectable({
    providedIn: 'root'
})
export class UniversalApiService {
    private requestService = inject(RequestService);
    private multisiteService = inject(MultisiteService);
    private urlService = inject(Url);

    flushUniversalCache(status: Status | undefined) {
        return this.requestService.send(
            status,
            {
                path: `universal/ci`
            },
            undefined,
            undefined,
            {
                api: 'node',
                method: 'GET'
            }
        );
    }

    flushByTag(
        status: Status | undefined,
        request: {
            type: string;
            ids: (string | number)[];
            flush: boolean;
        }
    ) {
        return this.requestService.send(
            status,
            {
                path: `api/prerender/ci/${request.type}/${request.ids.join(',')}`
            },
            undefined,
            undefined,
            {
                endpoint: this.urlService.storeUrl,
                method: 'GET'
            }
        );
    }
}
